import { create } from '@web3-storage/w3up-client'

export const IPFS_GATEWAY = "https://ipfs.io/ipfs/";

export const ipfsSaveContent = async (files) => {
    const client = await create()

    // get an email to use for the w3up account that will control the space
    const inputEmail = 'varahamihira2@gmail.com'

    // account associated with input email
    let myAccount
    if (inputEmail) {
    console.warn(`about to w3up client.login with email ${inputEmail}`)
    myAccount = await client.login(inputEmail)
    }

    const sharkDaoSpace = await client.createSpace('sharkDAO.xyz')

    // console.log('sharkDaoSpace', sharkDaoSpace)

    if (myAccount) {
    console.warn(`account ${myAccount.did()} is adding a provider to space ${sharkDaoSpace.did()}`)
    await myAccount.provision(sharkDaoSpace.did())
    }

    // this is what was missing but I didn't know it at the time
    await client.addSpace(await sharkDaoSpace.createAuthorization(client))
    await client.setCurrentSpace(sharkDaoSpace.did())
    const sharkPics = await client.uploadDirectory([files])

    await sharkDaoSpace.save()
    console.log(sharkPics.toString())

    return sharkPics.toString();

    // bafybeifd2hwj3ymtvdnzdxbenuucqqe6z3dbwt77etttyb2d3tu4cc2or4
};
